
export const resolveTreatments = (page = undefined, perpage = undefined, deleted = undefined) => {
    return ['$stateParams', 'treatmentsService', ($stateParams, treatmentsService) => {
        if (!$stateParams.filtertext) {
            return treatmentsService.findAll(page, perpage, deleted).then(list => list);
        }

        return treatmentsService.search('name', $stateParams.filtertext, page).then(list => list);
    }];
};

export const resolveTreatment = (param = 'treatment') => {
    return ['$stateParams', 'treatmentsService', ($stateParams, treatmentsService) => {
        return $stateParams[param] && $stateParams[param] > 0 ? treatmentsService.findById($stateParams[param]) : {};
    }];
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/treatment/resolvers/treatments.resolver.js